import { Element } from 'react-scroll';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import Maestro from './Maestro.png';
import ApplePay from './ApplePay.png';
import Visa from './Visa.png';
import MasterCard from './MasterCard.png';
import Cash from './Cash.png';
import AE from './american-express.png';
import { useTranslation } from 'react-i18next';

const PHONE_DISPLAY = '+39 342 911 8790';
const PHONE_LINK = '+393429118790';

const General = ({ id }) => {
  const { t } = useTranslation();

  const paymentMethods = [
    { src: Maestro, alt: 'Maestro' },
    { src: Visa, alt: 'Visa' },
    { src: AE, alt: 'American Express' },
    { src: MasterCard, alt: 'Mastercard' },
    { src: ApplePay, alt: 'Apple Pay' },
    { src: Cash, alt: t('demand_cash') },
  ];

  return (
    <Element name={id}>
      <section className="demandSection" aria-labelledby="demand-title">
        <div className="demandCard">
          <header className="demandHeader">
            <p className="demandEyebrow">{t('demand_header')}</p>
            <span className="demandAvailability">
              <span aria-hidden="true" />
              {t('demand_availability')}
            </span>
          </header>

          <div className="demandMain">
            <div className="demandIntro">
              <h2 id="demand-title">{t('demand_text')}</h2>
              <p>{t('demand_supportText')}</p>
            </div>

            <div className="demandContact">
              <p>{t('demand_contactLabel')}</p>
              <a className="demandPhoneNumber" href={`tel:${PHONE_LINK}`}>{PHONE_DISPLAY}</a>
              <div className="demandActions">
                <a className="demandButton demandCall" href={`tel:${PHONE_LINK}`}>
                  <LocalPhoneOutlinedIcon aria-hidden="true" />
                  {t('demand_call')}
                </a>
                <a
                  className="demandButton demandWhatsApp"
                  href={`https://wa.me/${PHONE_LINK.replace('+', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsAppIcon aria-hidden="true" />
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

          <div className="demandPayments">
            <div>
              <p>{t('demand_payments')}</p>
              <span>{t('demand_paymentsText')}</span>
            </div>
            <ul aria-label={t('demand_payments')}>
              {paymentMethods.map(({ src, alt }) => (
                <li key={alt}><img src={src} alt={alt} /></li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </Element>
  );
};

export default General;
